import React from 'react';
import ReactDom from 'react-dom';
import HeadNav from './_components/HeadNav';

const { path } = document.body.dataset;

ReactDom.render(<HeadNav path={path} />, document.getElementById('headNav'));
